import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';
import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { CONFIRM_BOOKING_BY_VENDOR, CONFIRM_BOOKING_BY_VENDOR_ERROR, CONFIRM_BOOKING_BY_VENDOR_SUCCESS } from '../../../actions.js';

function* confirmBookingByVendor({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/vendor/confirm-booking`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: {
        ...payload?.body,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: CONFIRM_BOOKING_BY_VENDOR_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CONFIRM_BOOKING_BY_VENDOR_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CONFIRM_BOOKING_BY_VENDOR_ERROR, payload: error });
  }
}

export function* watchConfirmBookingByVendor() {
  yield takeEvery(CONFIRM_BOOKING_BY_VENDOR, confirmBookingByVendor);
}

function* confirmBookingByVendorSaga() {
  yield all([fork(watchConfirmBookingByVendor)]);
}

export default confirmBookingByVendorSaga;
